import { styles } from './Costs.styles';

export const CostsLoading = () => (
	<>
		<header className={styles.topbar}>
			<div className="h-md w-[96px] animate-pulse rounded bg-grey-25" />
			<div className="h-md w-[128px] animate-pulse rounded bg-grey-25" />
		</header>
		<main className={styles.content}>
			<div className="flex flex-col gap-xs">
				<div className="h-sm w-[128px] animate-pulse rounded bg-grey-25" />
				<div className="h-[28px] w-[192px] animate-pulse rounded bg-grey-25" />
				<div className="h-md w-[288px] animate-pulse rounded bg-grey-25" />
			</div>
			<div className={styles.kpiGrid}>
				{['a', 'b', 'c'].map((k) => (
					<div key={`costs-kpi-${k}`} className="h-[92px] animate-pulse rounded-lg bg-grey-25" />
				))}
			</div>
			<div className="h-[140px] animate-pulse rounded-lg bg-grey-25" />
			<div className="h-[220px] animate-pulse rounded-lg bg-grey-25" />
		</main>
	</>
);
